export const BASE_URL: string = process.env.REACT_APP_API_KEY || '';
// export const BASE_URL:string="http://localhost:8085";
// Master Product
export const PRODUCT_MASTER_FIND_MANY: string = BASE_URL + '/products/master-product/find-many';
export const PRODUCT_MASTER_FIND_ONE: string = BASE_URL + '/products/master-product/find-one';
export const PRODUCT_MASTER_GET_PRODUCT_ON_HAND_FROM_SBC: string =
  BASE_URL + '/products/master-product/GetProductOnHandFromSBC';
export const SEARCH_MASTER_PRODUCT: string = BASE_URL + '/products/master-product/search';
export const GET_COUNT_MASTER_PRODUCT: string =
  BASE_URL + '/products/master-product/get-count-master-product';
export const PRODUCTS_BRAND_FIND_MANY: string = BASE_URL + '/products/brand/find-many';
export const MASTER_PRODUCT_UPDATE: string = BASE_URL + '/products/master-product/update';
export const MASTER_PRODUCT_UPDATE_MASTER_PRODUCT_CATEGORY: string =
  BASE_URL + '/products/master-product/updateMasterProductCategory';
export const REFRESH_PRODUCT_MERCHANT: string =
  BASE_URL + '/products/master-product/refresh-product-merchant';
export const GET_PRODUCT_FROM_SBC: string = BASE_URL + '/products/master-product/GetProductFromSBC';
export const GET_PRODUCT_ON_HAND_FROM_SBC: string =
  BASE_URL + '/products/master-product/GetProductOnHandFromSBC';
// Product
export const PRODUCT_FIND_MANY: string = BASE_URL + '/products/product/find-many';
export const PRODUCT_GET_COUNT_MERCHANT_PRODUCT: string =
  BASE_URL + '/products/product/get-count-merchant-product';
export const PRODUCT_CREATE: string = BASE_URL + '/products/product/create';
export const PRODUCT_DELETE: string = BASE_URL + '/products/product/delete';
export const PRODUCT_UPDATE: string = BASE_URL + '/products/product/update';
// Stock
export const FIND_MANY_INVENTORY_BY_MERCHANT_CODE: string =
  BASE_URL + '/products/master-product/find-many-inventory-by-merchantCode';

export const SEARCH_PRODUCT_MERCHANT: string = BASE_URL + '/products/product/search';

export const UPDATE_PRODUCT_MERCHANT: string =
  BASE_URL + '/products/master-product/refresh-product-merchantId';

  export const UPDATE_STOCK_FROM_SBC: string =
  BASE_URL + '/products/master-product/GetProductOnHandFromSBCByMerchantCode';